import { render } from "./index.vue?vue&type=template&id=6e2d18d4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=6e2d18d4&scoped=true&lang=css"
import "./index.vue?vue&type=style&index=1&id=6e2d18d4&lang=less&scoped=true"

import exportComponent from "D:\\works\\code\\wangyuan\\medical\\medical-h5\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e2d18d4"]])

export default __exports__